// extracted by mini-css-extract-plugin
module.exports = {"progressBarClass":"src-components-TimeboxProgressBar-styles-module__progressBarClass--biVf0"};